import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "presetId", "themePath"];
import styled from 'foundations-theming/utils';
import { useSelector } from 'react-redux';
import { getPreviewDomain } from '../../selectors/previewSelectors';
import {
// buildPresetTilePreviewUrl,
buildPreviewUrl } from '../../utils/urls';
import { View } from 'foundations-components/components/View';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TileIframe = styled.iframe.withConfig({
  displayName: "PresetTile__TileIframe",
  componentId: "sc-1ldspus-0"
})(({
  theme
}) => {
  return `
    width: 100%;
    height: 100%;
    border-width: ${theme.borderWidth['0']};
    border-radius: ${theme.borderRadius['100']};
  `;
});
const PresetTile = _ref => {
  let {
      onClick,
      presetId,
      themePath
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const previewDomain = useSelector(getPreviewDomain);
  // TODO: replace with tile preview url
  const previewUrl = buildPreviewUrl(previewDomain, themePath, null, '@hubspot/elevate/templates/lp-event-signup-two.hubl.html', {
    theme_preset_id: presetId
  });
  return /*#__PURE__*/_jsx(SelectableBox, Object.assign({
    type: "default",
    onClick: onClick,
    inlineSize: "100%",
    padding: "200"
  }, rest, {
    children: /*#__PURE__*/_jsxs(View, {
      blockSize: "150px",
      position: "relative",
      children: [/*#__PURE__*/_jsx(View, {
        blockSize: "100%",
        inlineSize: "100%",
        insetBlockStart: "0",
        insetInlineStart: "0",
        position: "absolute",
        onClick: onClick
      }), /*#__PURE__*/_jsx(TileIframe, {
        src: previewUrl || ''
      })]
    })
  }));
};
export default PresetTile;